import enviro from 'enviro';
import Raven from 'raven-js';
// @ts-expect-error unmigrated module
import { getCookie } from 'hub-http/helpers/cookies';
const ACCEPTANCE_TEST_COOKIE = 'hs_selenium';
const getIsAcceptanceTest = () => {
  return !!getCookie(ACCEPTANCE_TEST_COOKIE, document.cookie);
};
const loadScript = (src, id, defer = true, async = false) => {
  if (!id) {
    throw new Error(`An id must be provided.`);
  }
  if (document.getElementById(id)) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = id;
    script.type = 'text/javascript';
    script.src = src;
    script.defer = defer;
    script.async = async;
    script.onload = () => resolve();
    script.onerror = reject;
    const head = document.querySelector('head');
    if (head) {
      head.appendChild(script);
    }
  });
};
export function setupCookieBanner() {
  if (getIsAcceptanceTest()) {
    return Promise.resolve();
  }
  const hostname = enviro.isProd() ? 'js.hs-scripts.com' : 'js.hs-scriptsqa.com';
  const portalId = enviro.isProd() ? '53' : '100765651';
  return loadScript(`https://${hostname}/${portalId}.js`, 'hs-analytics-script', true, true).then(() => {
    document.body.classList.add('cookie-banner-top-static');
  }).catch(error => Raven.captureException(error));
}
export function setCookie(name, value) {
  const expires = new Date();
  expires.setTime(expires.getTime() + 30 * 24 * 60 * 60 * 1000); // 30 days
  const cookie = `${name}=${encodeURIComponent(value)};domain=.hubspot${enviro.isQa() ? 'qa' : ''}.com;expires=${expires.toUTCString()};path=/`;
  document.cookie = cookie;
}